function TermsAndConditions() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="prose prose-lg max-w-none">
        <h1 className="text-3xl font-bold mb-8">Terms and Conditions</h1>
        
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-8">
          <p className="font-semibold">PLEASE READ CAREFULLY BEFORE USING CONTENTCREATORAI.COM</p>
        </div>

        <p className="mb-6">
          Welcome to ContentCreatorAI.com (referred to as the "Website"). By accessing or using this Website, you agree to the following terms and conditions ("Terms"), which include our Privacy Policy. If you do not agree with these Terms, please do not use the Website.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
        <p className="mb-6">
          By visiting, using, or interacting with the Website, including accessing content, services, or advertisements, you accept these Terms in full. If you are under 18 years old, you are not permitted to use this Website in accordance with the Children's Online Privacy Protection Act (COPPA).
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">2. Use of Website Content</h2>
        <p className="mb-6">
          All content on this Website is proprietary and either owned or licensed by ContentCreatorAI.com. ("we," "us," "our").
        </p>
        <ul className="list-disc pl-6 mb-6">
          <li className="mb-2">You may not reproduce, distribute, sell, or use any content from this Website for commercial purposes without our explicit written permission.</li>
          <li className="mb-2">Unauthorized use of the content, including databases, code, and intellectual property, is strictly prohibited and may result in legal action.</li>
          <li className="mb-2">Violations of this section may result in damages and penalties as allowed by law.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">3. Account Responsibilities</h2>
        <ul className="list-disc pl-6 mb-6">
          <li className="mb-2">If you create an account, you must provide accurate and complete information.</li>
          <li className="mb-2">You are responsible for maintaining the security of your account and for all activities that occur under it.</li>
          <li className="mb-2">Notify us immediately of any unauthorized use or breach of security related to your account.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">4. Restrictions on Use</h2>
        <ul className="list-disc pl-6 mb-6">
          <li className="mb-2">Visitors may not hyperlink to this Website or reference it in any media without explicit authorization.</li>
          <li className="mb-2">Framing or co-branding this Website is prohibited without prior written consent.</li>
          <li className="mb-2">Any unauthorized activity will be subject to liquidated damages of $10,000 or as determined by applicable law, plus recovery of legal and associated costs.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">5. Disclaimers</h2>
        <h3 className="text-xl font-semibold mt-4 mb-2">Accuracy of Information:</h3>
        <p className="mb-4">The Website does not guarantee the accuracy or reliability of its content. Use the information at your own risk.</p>
        
        <h3 className="text-xl font-semibold mt-4 mb-2">Download Risks:</h3>
        <p className="mb-4">We do not guarantee that downloads are free of harmful components like viruses. You are responsible for protecting your devices with updated antivirus software.</p>
        
        <h3 className="text-xl font-semibold mt-4 mb-2">No Warranty:</h3>
        <p className="mb-6">All content and services are provided "as-is" without warranties of any kind, either express or implied.</p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">6. Limitation of Liability</h2>
        <p className="mb-2">To the fullest extent permitted by law:</p>
        <ul className="list-disc pl-6 mb-6">
          <li className="mb-2">We are not liable for damages resulting from your use of the Website, including indirect, incidental, or consequential damages.</li>
          <li className="mb-2">You waive any claims for damages, whether foreseeable or unforeseeable, arising from your interaction with the Website.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">7. Indemnification</h2>
        <p className="mb-6">
          You agree to indemnify and hold harmless ContentCreatorAI.com and its affiliates from any claims, damages, or costs (including attorney's fees) arising from your misuse of the Website, violation of these Terms, or infringement of third-party rights.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">8. Termination</h2>
        <ul className="list-disc pl-6 mb-6">
          <li className="mb-2">We reserve the right to suspend or terminate your access to the Website at any time for any reason.</li>
          <li className="mb-2">Termination does not waive any obligations or liabilities incurred prior to termination, including payment or indemnity obligations.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">9. Changes to Terms</h2>
        <ul className="list-disc pl-6 mb-6">
          <li className="mb-2">These Terms may be updated periodically. It is your responsibility to review these Terms regularly for changes.</li>
          <li className="mb-2">Continued use of the Website after modifications constitutes acceptance of the revised Terms.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">10. Governing Law and Dispute Resolution</h2>
        <ul className="list-disc pl-6 mb-6">
          <li className="mb-2">These Terms are governed by the laws of the State of Florida, USA.</li>
          <li className="mb-2">Any disputes shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association.</li>
          <li className="mb-2">Arbitration will take place in Florida, and each party will bear its own costs unless otherwise determined by the arbitrator.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">11. Privacy Policy</h2>
        <p className="mb-6">
          Your use of the Website is also governed by our Privacy Policy, which outlines how we collect, use, and protect your data. By using the Website, you consent to the practices described in the Privacy Policy.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">12. Contact Information</h2>
        <p className="mb-6">
          For questions or concerns about these Terms, please contact:
        </p>
        <div className="bg-gray-50 p-4 rounded-lg mb-6">
          <p>ContentCreatorAI.com</p>
          <p>Email: contact@contentcreatorai.com</p>
        </div>

        <p className="text-sm text-gray-600 mt-8">
          Last Updated: December 23, 2024
        </p>
      </div>
    </div>
  );
}

export default TermsAndConditions;
